import { FormikProps, withFormik } from "formik";
import { string, object } from "yup";
import { Input } from "../shared/Input";
import { Button } from "../shared/Button";
import { Modal } from "../shared/Modal";
import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

export interface IResetPasswordProps {
  onSubmit: (values: any, actions: any) => void;
  toggleForm: () => void;
}

interface FormikValues {
  otp: string;
  password: string;
}

function ResetPassword(props: FormikProps<FormikValues> & IResetPasswordProps) {
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    document.body.classList.add("body-no-scroll");
    return () => {
      document.body.classList.remove("body-no-scroll");
    };
  }, []);
  return (
    <Modal
      isOpen={true}
      setISOpen={props.toggleForm}
      title="Reset Password"
      content={
        <form onSubmit={props.handleSubmit}>
          <div className="flex items-center justify-center bg-white min-h-0.5  p-0">
            <div className="bg-white rounded-lg w-full max-w-sm p-3">
              <p className="text-sm text-gray-600 p-0">
                Are you hope Please Reset Your Password
              </p>
              <div className="grid gap-2 mt-2">
                <Input
                  label="OTP"
                  name="otp"
                  values={props.values}
                  errors={props.errors}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  touches={props.touched}
                  placeholder="Enter your OTP"
                  className="block w-full px-2 mt-2 py-2 border text-xs border-[#b0afb3] rounded-md focus:border-[#b0afb3] focus:outline-none"
                />
                <div className="relative">
                  <Input
                    label="Password"
                    name="password"
                    values={props.values}
                    errors={props.errors}
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    touches={props.touched}
                    placeholder="Enter your password"
                    className="block w-full px-2 mt-2 py-2 border text-xs border-[#b0afb3] rounded-md focus:border-[#b0afb3] focus:outline-none"
                    type={showPassword ? "text" : "password"}
                  />
                  <span
                    className="absolute right-3 top-[42px] transform  cursor-pointer text-gray-500"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <Button
                  className="bg-[#00B207] hover:opacity-70 rounded-full text-white py-2 w-full mt-4 hover:scale-105 duration-300"
                  name={props.isSubmitting ? "Submitting ..." : "Submit"}
                  type="submit"
                  loading={props.isSubmitting}
                  disabled={props.isSubmitting}
                />
              </div>
            </div>
          </div>
        </form>
      }
      showBackButton={true}
      onBackButtonClick={props.toggleForm}
    />
  );
}

export default withFormik<IResetPasswordProps, FormikValues>({
  validationSchema: object().shape({
    otp: string().required("OTP is required"),
    password: string()
    .required("New Password is required")
      .min(8, "New Password must be at least 8 characters")
      .matches(/[A-Z]/, "New Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "New Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "New Password must contain at least one digit")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "New Password must contain at least one special character"
      ),
  }),
  mapPropsToValues: () => ({
    otp: "",
    password: "",
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values, { setSubmitting });
  },
})(ResetPassword);
